import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import TweetDetails from './TweetDetails';
import TweetStart from './TweetStart';
import FindLocalRep from '../LocalRep/FindLocalRep';

const Tweet = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/tweet/start"
                            name="TweetStart"
                            exact
                            component={TweetStart}
                        />
                        <Route
                            path="/tweet"
                            name="TweetDetails"
                            exact
                            component={TweetDetails}
                        />
                        <Route
                            path="/tweet/findRep"
                            name="TweetFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Tweet;
